class GeolocationWrap {
  constructor() {
    this.geolocation = navigator.geolocation
  }

  hasGeolocationApi() {
    return !!this.geolocation
  }

  getPosition() {
    return new Promise((resolve, reject) => {
      this.geolocation.getCurrentPosition(resolve, reject);
    });
  }

  handleError(error) {
    var err_msg = "";
    switch(error.code)
    {
      case 1:
        err_msg = "位置情報の利用が許可されていません";
        break;
      case 2:
        err_msg = "デバイスの位置が判定できません";
        break;
      case 3:
        err_msg = "タイムアウトしました";
        break;
      default:
        break;
    }
    console.error(err_msg);
    window.alert(err_msg)
  }
}

export default GeolocationWrap;